import classNames from 'clsx';
import React, { useRef, useState } from 'react';

import type { Props } from '@swf/components/Inputs/StarsDatePicker';
import StarsDatePicker from '@swf/components/Inputs/StarsDatePicker';
import Arrow from '@swf/core/assets/icons/arrow.svg';

import styles from './DateTimePicker.scss';

const DateTimePicker: React.FC<Props & { containerClassName?: string }> = (props) => {
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const timePickerRef = useRef<HTMLDivElement>(null);
  const handleTimeIconClick = () => {
    const input = timePickerRef?.current?.querySelector('input:not([type=hidden])') as HTMLElement;

    input && input.click();
  };

  return (
    <div
      className={classNames(props.containerClassName, {
        [styles.dateOpen]: isDatePickerOpen,
        [styles.dateClosed]: !isDatePickerOpen
      })}
      ref={timePickerRef}
    >
      <StarsDatePicker
        {...props}
        className={classNames(styles.picker, props.className)}
        onClose={() => setIsDatePickerOpen(false)}
        onOpen={() => setIsDatePickerOpen(true)}
        icon={<Arrow className={styles.datePickerArrow} onClick={handleTimeIconClick} />}
      />
    </div>
  );
};

export default DateTimePicker;
